import { render } from "./VerifyAccountPage.vue?vue&type=template&id=32c4a040&scoped=true"
import script from "./VerifyAccountPage.vue?vue&type=script&lang=js"
export * from "./VerifyAccountPage.vue?vue&type=script&lang=js"

import "./VerifyAccountPage.vue?vue&type=style&index=0&id=32c4a040&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c4a040"]])

export default __exports__